export const normalizeSearchText = (value) => String(value || '')
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .toLowerCase().replace(/ß/g, 'ss').replace(/\s+/g, ' ').trim();

export const normalizeSearchPhone = (value) => String(value || '')
  .replace(/\D/g, '').replace(/^00/, '').replace(/^49/, '').replace(/^0/, '');

export const matchesCustomerSearch = (appointment, query) => {
  const text = normalizeSearchText(query);
  if (!text) return true;
  if (text.split(/\s+/).every((part) => normalizeSearchText(appointment.clientName).includes(part))) return true;
  if (/^[+\d\s()/-]+$/.test(text)) {
    const phone = normalizeSearchPhone(text);
    return phone.length >= 3 && normalizeSearchPhone(appointment.phone).includes(phone);
  }
  return false;
};

export const buildCustomerResults = (days = [], query = '') => {
  if (!query.trim()) return [];
  const groups = new Map();
  days.forEach((day) => (day.appointments || []).forEach((appointment) => {
    const name = normalizeSearchText(appointment.clientName);
    const phone = normalizeSearchPhone(appointment.phone);
    // Without a phone number there is no reliable identity; keep records separate.
    const key = phone ? `${name}|${phone}` : `${name}|appointment:${appointment.id}`;
    if (!groups.has(key)) groups.set(key, { key, appointments: [] });
    groups.get(key).appointments.push({ appointment, day });
  }));
  return [...groups.values()].filter((group) => group.appointments.some(({ appointment }) => matchesCustomerSearch(appointment, query)))
    .map((group) => {
      group.appointments.sort((a, b) => String(b.day.day).slice(0, 10).localeCompare(String(a.day.day).slice(0, 10))
        || String(b.appointment.time || '').localeCompare(String(a.appointment.time || '')));
      const latest = group.appointments[0];
      return { ...group, name: latest.appointment.clientName || 'Ohne Namen', phone: latest.appointment.phone || '', latestDay: latest.day.day };
    })
    .sort((a, b) => String(b.latestDay).localeCompare(String(a.latestDay)));
};
